// ======================================================================
// File Name       : SearchUser
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Button } from 'react-bootstrap';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../../constants/UserAttributeConstants';
import RenderField from '../../../utils/ReduxFormUtils';
import { convertNodeGroupToNodeString } from '../../../utils/UserUtils';
import CustomButton from '../../button/CustomButton';


class SearchUser extends Component {

  render() {
    const {
      userAttributeKeyNum,
      isDisplayHibernateUsers,
      userAttributeSearchText,
      groupList,
      selectedTargetGroup,
      dormantUserDataAcquisitionPermissionFlag,
    } = this.props;

    let groupNameString = '';
    selectedTargetGroup && (groupNameString =
      convertNodeGroupToNodeString(selectedTargetGroup.groupSecernId, groupList));
    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          this.props.handleSearchUserService();
        }}
        className='form-horizontal'
      >
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col sm={2} as={Form.Label}>
              ユーザー名
            </Col>
            <Col sm={9}>
              <RenderField type="text" name="userName" maxLength="40" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={2} as={Form.Label}>
              ログインID
            </Col>
            <Col sm={9}>
              <RenderField type="text" name="loginId" maxLength="40" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={2} as={Form.Label}>
              グループ名
            </Col>
            <Col sm={9}>
              <Button variant="primary" className="btn-96" onClick={this.props.handleShowGroupDlg}>
                グループ選択
              </Button>
            </Col>
          </Form.Group>
          { groupNameString &&
          <Form.Group className="form-info">
            <Col sm={2} as={Form.Label}>
            </Col>
            <Col sm={7} as={Form.Label} className='padding-left-clear'>
              {groupNameString}
            </Col>
            <Col sm={2}>
              <Button variant="primary" className="btn-96" onClick={this.props.handleRemoveSelectedGroup}>削除</Button>
            </Col>
          </Form.Group>}
          {/* Step 11.0.0 START - TAS-16209 */}
          {dormantUserDataAcquisitionPermissionFlag && (
            <Form.Group className="form-info">
              <Col sm={12}>
                <RenderField
                  name="isDisplayHibernateUsers"
                  value={isDisplayHibernateUsers}
                  type="checkbox"
                  label="休止状態のユーザーも表示する"
                />
              </Col>
            </Form.Group>
          )}
          {/* Step 11.0.0 END - TAS-16209 */}
          <Form.Group className="text-center">
            <Col sm={12} className="margin-top-10 padding-left-right-clear margin-bottom-15">
              {/* <Button bsStyle="primary" className="btn-96" type="submit">
                search
              </Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Col>
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { groupList, selectedTargetGroup } = state.group;
  const { dormantUserDataAcquisitionPermissionFlag } = state.authed.authedUser;
  return {
    groupList,
    selectedTargetGroup,
    dormantUserDataAcquisitionPermissionFlag
  };
};

export default connect(mapStateToProps)(SearchUser);

